import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "goal-excel-modal"
};
const _hoisted_2 = {
  class: "wrapper"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "1. 下载模板", -1);

const _hoisted_4 = /*#__PURE__*/_createTextVNode("下载模板");

const _hoisted_5 = {
  class: "wrapper"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "2. 上传模板", -1);

const _hoisted_7 = /*#__PURE__*/_createTextVNode("上传模板");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("确定");

import { ref, computed, watch } from 'vue';
import ExcelJS, { Workbook } from 'exceljs';
import { ElMessage } from 'element-plus';
export default {
  name: 'excel-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    timeType: [String, Number]
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    watch(() => props.modelValue, v => {
      if (v) {
        fileList.value = [];
      }
    });

    function download() {
      const workBook = new ExcelJS.Workbook();
      const workSheet = workBook.addWorksheet('sheet1');
      let commonColumns = [{
        header: '成员ID',
        key: 'supUserId'
      }, {
        header: '成员姓名',
        key: 'linkMan'
      }];

      if (props.timeType == 2) {
        workSheet.columns = [...commonColumns, {
          header: '分解任务量',
          key: 'value_0'
        }];
      } else {
        workSheet.columns = [...commonColumns, {
          header: '1月',
          key: 'value_1'
        }, {
          header: '2月',
          key: 'value_2'
        }, {
          header: '3月',
          key: 'value_3'
        }, {
          header: '4月',
          key: 'value_4'
        }, {
          header: '5月',
          key: 'value_5'
        }, {
          header: '6月',
          key: 'value_6'
        }, {
          header: '7月',
          key: 'value_7'
        }, {
          header: '8月',
          key: 'value_8'
        }, {
          header: '9月',
          key: 'value_9'
        }, {
          header: '10月',
          key: 'value_10'
        }, {
          header: '11月',
          key: 'value_11'
        }, {
          header: '12月',
          key: 'value_12'
        }];
      }

      props.data.forEach(item => {
        workSheet.addRow({
          supUserId: item.supUserId,
          linkMan: item.linkMan
        });
      });
      workBook.xlsx.writeBuffer().then(buffer => {
        let blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        let link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = '成员分解模板.xlsx';
        link.click();
        URL.revokeObjectURL(link.href);
      });
    }

    const fileList = ref([]);

    function submit() {
      console.log(fileList.value);
      let workBook = new ExcelJS.Workbook();
      let file = fileList.value[0].raw;
      let reader = new FileReader();

      reader.onload = e => {
        let data = e.target.result;
        workBook.xlsx.load(data).then(res => {
          let workSheet = res.worksheets[0];
          let rows = [...workSheet._rows];
          rows.shift();
          console.log(rows);
          let table = rows.map(item => {
            let obj = {
              supUserId: item.values[1],
              linkMan: item.values[2]
            };

            if (props.timeType == 2) {
              obj.value_0 = item.values[3] || null;
            } else {
              for (let i = 3; i < 15; i++) {
                obj[`value_${i - 2}`] = item.values[i] || null;
              }
            }

            return obj;
          });
          emit('success', table);
          visible.value = false;
        });
      };

      reader.readAsArrayBuffer(file);
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "模板导入",
        width: "500px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_button, {
          type: "primary",
          onClick: download
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_upload, {
          "file-list": fileList.value,
          "onUpdate:file-list": _cache[0] || (_cache[0] = $event => fileList.value = $event),
          accept: ".xlsx",
          autoUpload: false,
          limit: 1,
          "on-exceed": () => {
            _unref(ElMessage).error('已有EXCEL文件在上传列表中，请先删除再进行上传');
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary"
          }, {
            default: _withCtx(() => [_hoisted_7]),
            _: 1
          })]),
          _: 1
        }, 8, ["file-list", "on-exceed"])])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};